import { useState } from "react";
import { Check } from "lucide-react";
import api, { apiError } from "@/lib/api";
import { toast } from "sonner";

export default function AdminQuickStock({ product, onDone, compact = false }) {
  const [val, setVal] = useState(product.stock);
  const [busy, setBusy] = useState(false);

  const save = async () => {
    setBusy(true);
    try {
      await api.put(`/products/${product.id}/stock`, null, { params: { stock: Number(val) } });
      toast.success(`Stock mis à jour : ${val} ${product.unit}`);
      onDone?.(Number(val));
    } catch (e) {
      toast.error(apiError(e));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="flex items-center gap-1">
      <input
        type="number" min="0" value={val}
        onChange={(e) => setVal(e.target.value)}
        onKeyDown={(e) => e.key === "Enter" && save()}
        className={`border border-slate-300 rounded-lg px-2 py-1 text-sm text-right ${compact ? "w-16" : "w-24"}`}
        data-testid={`quickstock-input-${product.id}`}
      />
      <button onClick={save} disabled={busy}
        className="bg-[#0F172A] text-white text-xs font-bold px-2.5 py-1.5 rounded-lg disabled:opacity-50 flex items-center gap-1"
        data-testid={`quickstock-save-${product.id}`}>
        <Check className="w-3.5 h-3.5" /> {compact ? "" : "Réappro"}
      </button>
    </div>
  );
}
